//==========import components===============
import EventDo from 'components/whatWeDo/EventDo';
import HomeLayout from 'layouts/HomeLayout';
import { EventDoCardData } from 'helpers/commonHelper';
import JoinEventOrganizer from 'components/common/JoinEventOrganizer';
import TakeCare from 'components/common/TakeCare';

const WhatWeDo = () => {
  return (
    <div className='whatWeDoPage DBlock relative'>
      <EventDo data={EventDoCardData} />
      <TakeCare bgColor={true} />
      <JoinEventOrganizer bgColor={true} />
    </div>
  );
};

export default HomeLayout(WhatWeDo);
